module.exports = __webpack_public_path__ + "img/logo-toolbar.632975e4.png";